// The Flask client detail/mutation contract serializes the notification
// preferences as JSON booleans, while legacy Laravel payloads used 0/1.
// Normalize both into the 1/0 representation the client forms and SwitchField
// are built around so a boolean `true` never collapses to "off".
const ENABLED_STRINGS = ["1", "true", "yes", "on"];

export const clientNotificationFlagForForm = (value) => {
  if (typeof value === "string") {
    return ENABLED_STRINGS.includes(value.trim().toLowerCase()) ? 1 : 0;
  }
  return value === true || value === 1 ? 1 : 0;
};
